export var FormatMode;
(function (FormatMode) {
    FormatMode["Pad"] = "pad";
    FormatMode["BoxPad"] = "boxpad";
    FormatMode["Crop"] = "crop";
    FormatMode["Min"] = "min";
    FormatMode["Max"] = "max";
    FormatMode["Stretch"] = "stretch";
})(FormatMode || (FormatMode = {}));
class ImageTransform {
    constructor(imageUrl) {
        this._params = [];
        // Check if the url has an existing params and pass them into _params first
        const split = imageUrl.split('?');
        // This means it's got multiple ? in and I'm not dealing with that
        if (split.length > 2) {
            this._imageUrl = split[0];
            return;
        }
        // If we have a querystring
        if (split.length > 1) {
            // Split the querystring on &
            const queries = split[1].split('&');
            // Loop through and add them
            for (const query of queries) {
                this._params.push(query);
            }
        }
        this._imageUrl = split[0];
    }
    get url() {
        return `${this._imageUrl}?${this._params.join('&')}`;
    }
    addParameter(key, value) {
        if (this._imageUrl.length === 0) {
            return;
        }
        this._params.push(`${key}=${value.toString()}`);
    }
    width(width) {
        this.addParameter('width', width);
        return this;
    }
    height(height) {
        this.addParameter('height', height);
        return this;
    }
    mode(mode) {
        this.addParameter('mode', mode);
        return this;
    }
    entropyCrop() {
        this.addParameter('entropycrop', 1);
        return this;
    }
    toString() {
        return this.url;
    }
}
export default ImageTransform;
